import React, { useCallback } from 'react'
import IconButton from '@mui/material/IconButton'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { EntityDetail } from '@user/store/map/typings'
import { useDialogState } from '@user/utils/useDialogState'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { ErrorModalState } from '../../DrawerContentsSingle/hooks/useData'
import { AttachmentsDrawer } from '@user/components/Attachments/AddAttachmentsDrawer'
import {
  selectAllAttachments,
  useGetAttachmentsOnMount,
} from '@user/store/attachments'
import { useSelector } from 'react-redux'
import Badge from '@mui/material/Badge'

type Props = {
  entityDetails: EntityDetail
  canUpdate: boolean
  serviceLocation: LocationDTO
  setErrorModal: (errorModal: ErrorModalState) => void
}

export function Attachments({
  entityDetails,
  canUpdate,
  serviceLocation,
  setErrorModal,
}: Props) {
  const [viewOpen, showView, hideView] = useDialogState()
  const attachments = useSelector(selectAllAttachments)
  const attachmentsStatus = useGetAttachmentsOnMount(
    entityDetails?.id || -1,
    entityDetails?.entityType === ENTITY_TYPES.Lead,
  )
  const attachmentsLoading = attachmentsStatus === 'pending'

  const handleViewClick = useCallback(async () => {
    if (canUpdate) {
      showView()
    } else {
      setErrorModal({
        open: true,
        title: 'Attachments',
        message: "You don't have permission to perform this action.",
      })
    }
  }, [canUpdate, showView, setErrorModal])

  return (
    <>
      <Badge
        color="primary"
        badgeContent={attachmentsLoading ? null : attachments.length}
        overlap="circular"
      >
        <IconButton
          sx={{
            backgroundColor: '#EAEEF2',
          }}
          size="large"
          onClick={handleViewClick}
        >
          <AttachFileIcon color={'primary'} />
        </IconButton>
      </Badge>
      <AttachmentsDrawer
        entityId={entityDetails.id}
        entityType={entityDetails.entityType}
        canUpdate={canUpdate}
        open={viewOpen}
        onClose={hideView}
        currentServiceLocation={serviceLocation}
      />
    </>
  )
}
